import React from 'react';
import { ApSelect, colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
import { black, grey500 } from 'styles/colors';

export const Wrapper = styled.div`
	padding: 7% 7% 0;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	min-width: 350px;
`;

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;

export const Message = styled.div`
	width: 100%;
	display: flex;
	padding: 3% 0 0 0;
`;

export const Text = styled.div`
	ul {
		padding: 10px 10px 10px 40px;
	}

	li {
		list-style: initial;
	}

	p {
		font-size: 14px;
		font-weight: 500;
		color: ${colors.orange};
	}
`;

export const RecordWraper = styled.div`
	padding: 8% 0 0 0;
	#logs_title {
		font-size: 14px;
		letter-spacing: 0.3px;
		color: ${colors.grey5};
		padding: 0 0 5px 0;
	}
`;

export const Row = styled.div`
	display: flex;
	height: 48px;
	padding: 0 12px;
	align-items: center;
	border-top: 1px solid ${colors.grey4};
	background-color: white;

	&:last-child {
		border-bottom: 1px solid ${colors.grey4};
	}
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 24px;
	padding: 0 16px;
	color: ${colors.grey8};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Helper = styled.div`
	color: black;
	font-size: 11px;
	line-height: 13px;
	padding: 0 8px;
`;

export const FormSummary = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const FormSummaryLine = styled.tr`
	text-align: left;
`;

export const FormSummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	text-transform: uppercase;
	font-weight: normal;
	padding: 3px 30px 3px 12px;
`;

export const FormSummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 5px 0;
	height: 50px;
	width: 640px;
	min-width: 360px;
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 384px !important;
	height: 34px !important;

	${({ small }) =>
		small &&
		css`
			max-width: 175px !important;
			min-width: 175px !important;
		`};
`;

export const FormValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;

	input {
		height: 34px;
	}
`;

export const SelectWrapper = styled.div`
	label {
		display: none;
	}

	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 0;
		right: 0;
	}
`;
